module.exports = __webpack_public_path__ + "img/sql.6c0b7f59.svg";